/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{featureDefinitions as o}from"./definitions.js";function i(i){for(const n in i)o[n]={...o[n],...i[n]}}export{i as loadFeatures};
//# sourceMappingURL=load-features.js.map
